<template>
  <div class="overlay-editor-wrapper">
    <div class="panel-top">

      <div class="lang-selector-holder d-flex align-items-center">
        <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:') }}</label>
        <LangSelector v-model="lang" />
      </div>

      <a href="javascript:void(0);" class="back_trigger" @click="cancel">
        <span class="icon icon-cross"></span>
      </a>
    </div>
    <div class="panel-middle">
      <h3 class="panel-top-name">{{ $static('ei.ed', 'Редагування сторінки') }}</h3>

      <div class="row">
        <div class="col-6">
          <div class="custom-label" style="color:#565656; margin-top: 25px; font-style: italic">
            {{ $static('ei.t222',
              'Завантаження фотографій. Рекомендований розмір 570 x 570 px. Крім того, радимо оптимізувати зображення') }}
          </div>

          <div class="files-uploader default-files-uploader ">
            <div class="files-uploader-holder" v-if="!item.images || item.images.length === 0" @click="openFileManager">
              <span class="icon icon-cloud-upload"></span>
              <p>{{ $static('ei.tf1', 'Завантажте свої зображення сюди') }}</p>
              <span>{{ $static('ei.tf2', 'Зображення повинні мати розширення png або jpg') }}</span>
            </div>

            <div class="uploader-previews" @click="openFileManager" v-else>
              <div class="image bg" v-for="(image, index) in item.images"
                :style="{ backgroundImage: $filters.backgroundImage(image) }">
                <a href="javascript:void(0)" class="btn-icon btn-remove btn-small"
                  @click.prevent.stop="delImage(item.images, index)">
                  <span class="icon icon-trash-filled"></span>
                </a>
                <a href="javascript:void(0)" class="btn-icon  btn-small"
                  @click.prevent.stop="moveImage(item.images, index, -1)" style="bottom: inherit;top: 3px;left: 3px;">
                  <span class="icon icon-left"></span>
                </a>
                <a href="javascript:void(0)" class="btn-icon  btn-small"
                  @click.prevent.stop="moveImage(item.images, index, 1)" style="bottom: inherit;top: 3px;right: 3px;">
                  <span class="icon icon-right"></span>
                </a>
              </div>
            </div>
            <div class="image image-placeholder" @click="openFileManager">
              <div class="text">570 x 570</div>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="custom-label" style="color:#565656; margin-top: 25px; font-style: italic">
            {{ $static('ei.t2221',
              'Завантаження відео. Рекомендований розмір 570 x 570 px. Крім того, радимо оптимізувати відео') }}
          </div>
          <div class="files-uploader default-files-uploader">
            <div class="files-uploader-holder" v-if="!videos || videos.length === 0" @click="openFileManagerVideo">
              <span class="icon icon-cloud-upload"></span>
              <p>{{ $static('ei.tfv1', 'Завантажте свої відео сюди') }}</p>
              <span>{{ $static('ei.tfv2', 'Відео повинні мати розширення webm або mp4') }}</span>
            </div>

            <div class="uploader-previews" @click="openFileManagerVideo" v-else>
              <div class="image bg" v-for="(image, index) in videos"
                :style="{ backgroundImage: $filters.backgroundImage(image) }">
                <a href="javascript:void(0)" class="btn-icon btn-remove btn-small"
                  @click.prevent.stop="delImage(videos, index)">
                  <span class="icon icon-trash-filled"></span>
                </a>
                <a href="javascript:void(0)" class="btn-icon btn-small"
                  @click.prevent.stop="moveImage(videos, index, -1)" style="bottom: inherit;top: 3px;left: 3px;">
                  <span class="icon icon-left"></span>
                </a>
                <a href="javascript:void(0)" class="btn-icon btn-small"
                  @click.prevent.stop="moveImage(videos, index, 1)" style="bottom: inherit;top: 3px;right: 3px;">
                  <span class="icon icon-right"></span>
                </a>
              </div>
            </div>
            <div class="image image-placeholder" @click="openFileManagerVideo">
              <div class="text">570 x 570</div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group" id="t2">
            <div class="custom-label">{{ $static('ei.t2', 'Назва продукту:') }}</div>

            <input type="text" class="form-control custom-input" v-if="basicLang" v-model="item.title">
            <input type="text" class="form-control custom-input" v-else :placeholder="item.title"
              :value="translate.title" @change="e => setTranslate('title', e.target.value)">
          </div>
          <div class="form-group" id="t3">
            <label class="custom-label">{{ $static('ei.t3', 'Категорія продукції:') }}</label>
            <div class="selector-holder">
              <v-select id="editor_category" :options="categoriesOptions" :searchable="false" :reduce="c => c.value"
                v-model="category">
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                        fill="#212121" />
                    </svg>
                  </span>
                </template>
              </v-select>
            </div>
          </div>

        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group" id="t4">
                <div class="custom-label">{{ $static('ei.t4', 'Ціна:') }}</div>
                <input type="text" class="form-control custom-input" v-model.number="item.price">
              </div>
              <div class="form-group" id="t7">
                <div class="custom-label">{{ $static('ei.t7', 'Стара ціна:') }}</div>
                <input type="text" class="form-control custom-input" v-model.number="item.price_old">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" id="t13">
                <div class="custom-label">{{ $static('ei.bon', 'Кількість бонусів:') }}</div>
                <input type="text" class="form-control custom-input" v-model.number="bonusCount">
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="option-box" style="margin-top:0;margin-bottom: 20px;">
            <div class="option-line" id="t5">
              <div class="option-name">{{ $static('ei.t5', 'Доступність продукту') }}</div>
              <div class="toggle-holder">
                <div class="toggler r">
                  <input type="checkbox" class="toggle-check" v-model="item.stock">
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>
            <div class="option-line" id="t6">
              <div class="option-name">{{ $static('ei.t6', 'Приховати товар') }}</div>
              <div class="toggle-holder">
                <div class="toggler r">
                  <input type="checkbox" class="toggle-check" v-model="item.hidden">
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>
            <div class="option-line" id="t6">
              <div class="option-name">{{ $static('ei.tdigital6', 'Цифровий товар') }}</div>
              <div class="toggle-holder">
                Coming Soon
                <!--                <div class="toggler r">-->
                <!--                  <input type="checkbox" class="toggle-check" v-model="item.hidden">-->
                <!--                  <div class="knobs"></div>-->
                <!--                  <div class="layer"></div>-->
                <!--                </div>-->
              </div>
            </div>


          </div>

        </div>
        <div class="col">
          <div class="option-box" style="margin-top:0;margin-bottom: 20px;">
            <div class="option-line" id="t8">
              <div class="option-name">{{ $static('ei.t8', 'Вивести в топ') }}</div>
              <div class="toggle-holder">
                <div class="toggler r">
                  <input type="checkbox" class="toggle-check" v-model="item.priority">
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>
            <div class="option-line" id="t9">
              <div class="option-name">{{ $static('ei.t9', 'Новинки') }}</div>
              <div class="toggle-holder">
                <div class="toggler r">
                  <input type="checkbox" class="toggle-check" v-model="hot">
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>
            <div class="option-line" id="tserv9">
              <div class="option-name">{{ $static('ei.tserv9', 'Заявка') }}</div>
              <div class="toggle-holder">
                <div class="toggler r">
                  <input type="checkbox" class="toggle-check" v-model="isService">
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group mb-0" id="e1">
            <label class="custom-label">{{ $static('ei.e1', 'Додати в рекомендації') }}</label>
            <div class="selector-holder">
              <v-select id="together_products" :title="$static('ei.e2', 'Оберіть товар')"
                :placeholder="$static('ei.e3', 'Оберіть товар')" @open="onOpen" @search="fetchOptions" @close="onClose"
                :reduce="c => c.item" :options="paginated" v-model="upsaleItems">
                <template #option="{ label, item }" class="together_list-item">
                  <p style="margin: 0">{{ label }}</p>
                  <img v-if="item.images.length" :src="item.images[0]">
                </template>
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                        fill="#212121" />
                    </svg>
                  </span>
                </template>

                <template #list-footer>
                  <li v-show="hasNextPage" ref="load" class="loader">
                    {{ $static('ei.e4', 'Завантажити більше опцій...') }}
                  </li>
                </template>
              </v-select>
            </div>
            <div class="tags tags-together">
              <div class="tag" v-for="(tag, index) in upsale" :key="index">
                {{ tag.title }}
                <img v-if="tag.image" :src="tag.image">
                <a href="javascript:void(0)" @click.prevent.stop="removeUpsaleTag(index)" class="tag-remove">
                  <span class="icon icon-cross"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="item.id">
        <div class="col-10">
          <div class="form-group mb-0" id="gr1">
            <label class="custom-label">{{ $static('ei.gr1', 'Группа товару') }}</label>
            <div class="selector-holder">
              <v-select id="together_products" :title="$static('ei.gr2', 'Оберіть товар')"
                :placeholder="$static('ei.gr3', 'Оберіть товар')" @open="onOpen" @search="fetchOptions" @close="onClose"
                :reduce="c => c.item" :options="paginated" v-model="groupList">
                <template #option="{ label, item }" class="together_list-item">
                  <p style="margin: 0">{{ label }}</p>
                  <img v-if="item.images.length" :src="item.images[0]">
                </template>
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                        fill="#212121" />
                    </svg>
                  </span>
                </template>

                <template #list-footer>
                  <li v-show="hasNextPage" ref="load" class="loader">
                    {{ $static('ei.e4', 'Завантажити більше опцій...') }}
                  </li>
                </template>
              </v-select>
            </div>

            <div class="tags tags-together">
              <div class="tag" v-for="(item, index) in group" :key="index">
                {{ item.title }}
                <img v-if="item.preview" :src="item.preview">
                <img v-else-if="item.images?.length" :src="item.images[0]">
                <a href="javascript:void(0)" @click.prevent.stop="removeGroup(index)" class="tag-remove">
                  <span class="icon icon-cross"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group" :class="{ 'disabled': group.length }">
            <div class="custom-label">{{ $static('ei.idgr', 'ID группи') }}</div>
            <input type="text" class="form-control custom-input" v-model="group_id_set">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="custom-tabs">
            <ul class="nav nav-tabs">
              <li class="active"><a data-toggle="tab" href="#tab1">{{ $static('ei.tab1', 'Опис') }}</a></li>
              <li><a data-toggle="tab" href="#tab2">{{ $static('ei.tab2', 'Характеристики') }}</a></li>
            </ul>

            <div class="tab-content ">
              <div id="tab1" class="tab-pane fade in active">
                <!--                <div class="form-group">-->
                <!--                  <div class="custom-label">Название вкладки:</div>-->
                <!--                  <input type="text" class="form-control custom-input" value="Опис">-->
                <!--                </div>-->
                <div class="custom-editor-holder" v-if="basicLang">
                  <editor :small="true" v-model="item.description"></editor>
                </div>
                <div class="custom-editor-holder" v-else>
                  <editor :small="true" :placeholder="item.description" v-model="translate.description"
                    @update:modelValue="e => setTranslate('description', e)"></editor>
                </div>
              </div>
              <div id="tab2" class="tab-pane fade">
                <!--                                <div class="form-group">-->
                <!--                                  <div class="custom-label">Название вкладки:</div>-->
                <!--                                  <input type="text" class="form-control custom-input" value="Інгредієнти">-->
                <!--                                </div>-->
                <div class="custom-editor-holder" v-if="basicLang">
                  <editor :small="true" v-model="item.advanced.text1"></editor>
                </div>
                <div class="custom-editor-holder" v-else>
                  <editor :small="true" :placeholder="item.text1" v-model="translate.text1"
                    @update:modelValue="e => setTranslate('text1', e)"></editor>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


      <div class="row">
        <div class="col">
          <!--sizes-->
          <div class="size-panel mb-1" v-for="(option, index) in optionsTags" :key="index">
            <div class="custom-label">{{ option.option }}:</div>
            <div class="size-checkbox-group">
              <!--size checkbox-->
              <div class="option-checkbox" v-for="(item, index) in option.list.sort((a, b) => a.order - b.order)"
                :key="index">
                <input :id="item.option_id + index" type="checkbox" @change="selectOption(item.option_id, item.id)"
                  :checked="selectedOption(item.option_id, item.id) > -1" :value="item.id" :name="option.option_id">
                <label :for="item.option_id + index">{{ item.name }}</label>
              </div>
              <!--end size checkbox-->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <!--          <div class="unique-options d-flex align-items-center mt-2 mb-3">-->
          <!--            <div class="custom-label mb-0">{{ $static('ei.mod-title', 'Модифікації:') }}</div>-->
          <!--            <div class="buttons-panel d-flex">-->
          <!--              <button class="default-btn btn-accent btn-with-icon btn-extrasmall" @click="openUniqueOptions">-->
          <!--                <span class="text">Редагувати</span>-->
          <!--                <span class="icon icon-edit"></span>-->
          <!--              </button>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="unique-options d-flex align-items-center mt-2 mb-3">
            <div class="custom-label mb-0">{{ $static('ei.un-opt-title', 'Унікальні опції:') }}</div>
            <div class="buttons-panel d-flex">
              <button class="default-btn btn-accent btn-with-icon btn-extrasmall" @click="openUniqueOptions">
                <span class="text">{{ $static('ei.opt-btn1', 'Редагувати') }}</span>
                <span class="icon icon-edit"></span>
              </button>
              <button class="default-btn btn-white btn-green btn-with-icon btn-extrasmall" @click="copyUniqueOptions"
                v-if="this.selected.advanced.uOption">
                <span class="text">{{ $static('ei.opt-btn2', 'Копіювати') }}</span>
                <span class="icon icon-3copy3"></span>
              </button>
              <button class="default-btn btn-white btn-green btn-with-icon btn-extrasmall" @click="putUniqueOptions">
                <span class="text">{{ $static('ei.opt-btn3', 'Вставити') }}</span>
                <span class="icon icon-add"></span>
              </button>
              <button class="default-btn btn-white btn-green btn-with-icon btn-extrasmall" @click="removeUniqueOptions"
                v-if="this.selected.advanced.uOption">
                <span class="text">{{ $static('ei.opt-btn4', 'Видалити') }}</span>
                <span class="icon icon-trash"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <div class="custom-label">{{ $static('ei.srt', 'Номер сортування') }}</div>
            <input type="text" class="form-control custom-input" v-model="item.sort">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="custom-label">{{ $static('ei.artcl', 'Артикул') }}</div>
            <input type="text" class="form-control custom-input" v-model="item.article">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <div class="custom-label">{{ $static('ceo.t1', 'Мета-тег Title') }}</div>
            <input type="text" class="form-control custom-input" v-model="metaTitle">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <div class="custom-label">{{ $static('ceo.t2', 'Мета-тег description') }}</div>
            <textarea class="form-control custom-input" v-model="metaDescription"></textarea>
          </div>
        </div>
      </div>

    </div>
    <div class="panel-bottom">
      <button class="transparent-btn default-btn back_trigger" @click="cancel">
        <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
      </button>
      <button class="default-btn btn-accent" @click="save">
        <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
      </button>
      <!--      <button class="waves-effect waves-light default-btn btn-remove" @click="remove">-->
      <!--        <span class="text">Удалить товар</span>-->
      <!--      </button>-->
    </div>
  </div>


  <Teleport to="body">
    <!-- EDITOR WRAPPER-->
    <div class="overlay-editor options-editor" id="optionsEditor" v-if="selected && selected.advanced">
      <div class="overlay-editor-wrapper">
        <div class="panel-top">
          <div class="lang-selector-holder d-flex align-items-center">
            <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:') }}</label>
            <LangSelector v-model="lang" />
          </div>
          <a href="javascript:void(0);" class="back_trigger" @click="closeUniqueOptions">
            <span class="icon icon-cross"></span>
          </a>
        </div>
        <div class="panel-middle">
          <div class="tabs-wrapper">
            <Teleport to="body">
              <div class="picket-container" style="position: absolute;z-index: 11111" v-if="colors"
                :style="{ left: colorPicker.x + 'px', top: colorPicker.y + 'px' }">
                <chrome-picker v-model="colors"></chrome-picker>
              </div>
            </Teleport>
            <!--            <h4>Модифікації</h4>-->
            <!--            <div class="repeater">-->
            <!--              <div class="repeat-top d-flex w-100">-->
            <!--                <div class="name custom-label tag-name w-20">Назва</div>-->
            <!--                <div class="name custom-label tag-name w-20">Модифікація</div>-->
            <!--                <div class="name custom-label tag-name w-20">Артикул</div>-->
            <!--                <div class="d-flex price-name-group w-25">-->
            <!--                  <div class="name  custom-label w-50">-->
            <!--                    {{ $static('option.price', 'Ціна') }}-->
            <!--                  </div>-->
            <!--                  <div class="name custom-label w-50">-->
            <!--                    {{ $static('option.old_price', 'Стара ціна') }}-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="d-flex color-name-group w-10" style="padding-left:15px">-->
            <!--                  <div class="name custom-label w-50" style="padding-left:0">{{ $static('option.imag', 'Img') }}</div>-->
            <!--                  <div class="name custom-label w-50">{{ $static('option.color', 'Колір') }}</div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <ItemModificationRow v-for="(mod, index) in modList" :key="index" :item="mod" :lang="lang"-->
            <!--                                   @remove="removeModification(index)" @down="swapMod(index, index + 1)" @up="swapMod(index, index - 1)"-->
            <!--                                   @color="(event) => openColorPicker(event, mod)" :basic_price="index === 0 ? item.price : -1"/>-->
            <!--              <a href="javascript:void(0)" class="default-link" @click="addMoreModification">-->
            <!--                <span class="text">{{ $static('option.add', 'Додати більше') }}</span>-->
            <!--                <span class="icon icon-add"></span>-->
            <!--              </a>-->
            <!--            </div>-->

            <!--            <hr>-->

            <h4>{{ $static('ei.title-uniq', 'Унікальні опції') }}</h4>
            <div class="tab-links-holder d-flex align-items-center tab-links-holder__scroll">
              <ul class="tab-links">
                <li class="tab-link" v-for="(o, i) in selected.advanced.uOption"
                  :class="{ 'active': uOptionIndex === i }">
                  <a class="default-btn"
                    :class="{ 'btn-white': uOptionIndex === i, 'transparent-btn': uOptionIndex !== i }"
                    @click="uOptionIndex = i">{{ o.name }}</a>
                </li>
              </ul>
              <div class="create-option">
                <div class="tip" style="position:relative;white-space: nowrap">
                  <Popper arrow content="Створити опцію" hover placement="top">
                    <a class="btn-icon btn-rounded" @click="newOption">
                      <span class="icon icon-add"></span>
                    </a>
                  </Popper>
                </div>
              </div>
            </div>
            <div class="tab-content-wrapper" v-if="uOption">
              <Teleport to="body">
                <div class="picket-container" style="position: absolute;z-index: 11111" v-if="colors"
                  :style="{ left: colorPicker.x + 'px', top: colorPicker.y + 'px' }">
                  <chrome-picker v-model="colors"></chrome-picker>
                </div>
              </Teleport>

              <div class="tab-body panel panel-bordered">
                <div class="unique-option-func d-flex">
                  <div class="form-group w-25 mb-0" style="padding-right: 20px;">
                    <input type="text" class="form-control custom-input price-input" placeholder="Назва опції"
                      v-if="basicLang" v-model="uOption.name">
                    <input type="text" class="form-control custom-input price-input" v-else :placeholder="uOption.name"
                      :value="translateOptions.name" @change="e => setTranslateOptions('name', e.target.value)">

                  </div>
                  <div class="option-box d-flex w-75 mt-0">
                    <div class="option-line w-50 mt-0" style="padding-right: 20px;">
                      <div class="option-name">{{ $static('ei.select-one-opt', 'Вибрати тільки одну') }}</div>
                      <div class="toggle-holder">
                        <div class="toggler r">
                          <input type="checkbox" class="toggle-check" v-model="uOption.single">
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                    </div>
                    <div class="option-line w-50 mt-0" style="padding-left: 20px;">
                      <div class="option-name">{{ $static('ei.surely', 'Обов\'язкова') }}</div>
                      <div class="toggle-holder">
                        <div class="toggler r">
                          <input type="checkbox" class="toggle-check" v-model="uOption.req">
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                    </div>
                    <div class="option-line w-50 mt-0" style="padding-left: 20px;">
                      <div class="option-name">{{ $static('ei.off', 'Вимкнути') }}</div>
                      <div class="toggle-holder">
                        <div class="toggler r">
                          <input type="checkbox" class="toggle-check" v-model="uOption.off">
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                    </div>
                    <button class="default-btn btn-white btn-green btn-with-icon" style="margin-left: 15px"
                      @click="removeOptionTitle(uOptionIndex)">
                      <span class="text">{{ $static('ei.opt-btn4', 'Видалити') }}</span>
                      <span class="icon icon-trash"></span>
                    </button>
                  </div>
                </div>

                <div class="repeater">
                  <div class="repeat-top d-flex w-100">
                    <div class="name custom-label tag-name w-25">{{ $static('ei.label-name', 'Назва мітки') }}</div>
                    <div class="d-flex price-name-group w-25">
                      <div class="name  custom-label w-50">
                        {{ $static('option.price', 'Ціна') }}
                      </div>
                      <div class="name custom-label w-50">
                        {{ $static('option.old_price', 'Стара ціна') }}
                      </div>
                    </div>
                    <div class="d-flex color-name-group w-15" style="padding-left: 20px">
                      <div class="name custom-label w-50">{{ $static('option.imag', 'Img') }}
                      </div>
                      <div class="name custom-label w-50" style="position:relative; left: 15px;">
                        {{ $static('option.color', 'Колір') }}
                      </div>
                    </div>
                  </div>

                  <OptionEditorFull v-for="(i, index) in optionList" :key="index" :item="i" :lang="lang"
                    :swappable="true" @remove="removeOption(index)" @down="swap(index, index + 1)"
                    @up="swap(index, index - 1)" @color="(event) => openColorPicker(event, i)" />

                  <a href="javascript:void(0)" class="default-link" @click="addMore">
                    <span class="text">{{ $static('option.add', 'Додати більше') }}</span>
                    <span class="icon icon-add"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-bottom">
          <button class="transparent-btn default-btn back_trigger" @click="cancelOptions">
            <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
          </button>
          <button class="default-btn btn-accent" @click="save">
            <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
          </button>
          <!--      <button class="waves-effect waves-light default-btn btn-remove" @click="remove">-->
          <!--        <span class="text">Удалить товар</span>-->
          <!--      </button>-->
        </div>
      </div>
    </div>
    <!--END EDITOR WRAPPER-->
  </Teleport>
</template>

<script>
import api from '@/api'
import { Chrome } from '@lk77/vue3-color'
import OptionEditorFull from '@/components/OptionEditorFull';
import { nextTick } from 'vue'
import Editor from './Editor';
import LangSelector from './LangSelector';
import ItemModificationRow from '@/components/ItemModificationRow';

export default {
  name: 'EditItemAdmin',
  components: {
    OptionEditorFull,
    LangSelector,
    Editor,
    'chrome-picker': Chrome,
    ItemModificationRow
  },
  props: ['item'],
  emits: ['save', 'add'],
  data() {
    return {
      uOptionIndex: 0,
      limit: 5,
      observer: null,
      lang: '',
      i18n: {},
      load: false,
      errors: {},

      cache: undefined,
      selectColor: undefined,
      selectImage: undefined,
      colorPicker: { x: 0, y: 0 },
      group: [],
      searchResult: [],
      set_group_id: undefined
    }
  },
  methods: {
    addMore() {
      let more = Object.assign({}, this.uOption.list[this.uOption.list.length - 1], {
        color: null,
        image: null
      });
      more.order = this.uOption.list.length;
      more.id = undefined;
      delete more.translate;
      more._id = new Date().getTime();
      this.uOption.list.push(JSON.parse(JSON.stringify(more)));
    },
    addMoreModification() {
      let more = {}
      if (this.modList?.length) {
        more = Object.assign({}, this.modList[this.modList.length - 1], {
          color: null,
          image: null,
          order: this.modList.length
        });
      } else {
        more = {
          color: null,
          image: null,
          order: 0
        };
      }
      more.id = undefined;
      delete more.translate;
      more._id = new Date().getTime();
      if (this.modList?.length) {
        this.modList.push(JSON.parse(JSON.stringify(more)));
      } else {
        this.modList = [more]
      }
    },
    removeModification(index) {
      this.modList.splice(index, 1);
    },
    swap(index1, index2) {
      if (index2 > this.selected.advanced.uOption[this.uOptionIndex].list.length - 1 || index2 < 0) {
        return
      }
      let list = [...this.selected.advanced.uOption[this.uOptionIndex].list];
      list[index1].order = index2;
      list[index2].order = index1;
      this.selected.advanced.uOption[this.uOptionIndex].list = list;
    },
    swapMod(index1, index2) {
      console.log('swapMod', index1, index2);
      if (index2 > this.modList.length - 1 || index2 < 0) {
        return
      }
      let list = [...this.modList];
      list[index1].order = index2;
      list[index2].order = index1;
      this.modList = list;
    },
    openColorPicker(event, item) {
      // console.log(event, item);
      if (this.selectColor !== undefined && this.selectColor.id === item.id) {
        this.selectColor = undefined;
        return
      }
      this.colorPicker.x = Math.min(event.pageX, window.innerWidth - 230);
      this.colorPicker.y = event.pageY;
      this.selectColor = item;
      window.document.getElementById('optionsEditor').addEventListener('click', this.closeColorPicker)
      window.document.getElementsByClassName('back-blur')[0].addEventListener('click', this.closeColorPicker)
    },
    closeColorPicker(event) {
      this.selectColor = undefined;
      window.document.getElementById('optionsEditor').removeEventListener('click', this.closeColorPicker)
      window.document.getElementsByClassName('back-blur')[0].removeEventListener('click', this.closeColorPicker)
    },
    removeOption(index) {
      this.uOption.list.splice(index, 1);
    },
    removeOptionTitle(index) {
      this.selected.advanced.uOption.splice(index, 1);
      this.uOptionIndex = 0
    },

    newOption() {
      if (!Array.isArray(this.selected.advanced.uOption)) {
        this.selected.advanced.uOption = []
      }
      let count = this.selected.advanced.uOption.length + 1
      this.selected.advanced.uOption.push(
        {
          name: `Option ${count}`,
          list: []
        })
    },

    openUniqueOptions() {
      window.$('#optionsEditor').addClass('active');
      if (this.selected?.advanced?.uOption) {
        this.cache = JSON.parse(JSON.stringify(this.selected.advanced.uOption))
      } else {
        this.cache = undefined
      }
    },
    copyUniqueOptions() {
      window.uOptionsSave = JSON.stringify(this.selected.advanced.uOption);

      this.$notify({
        title: this.$static('options.title', 'Опції'),
        text: this.$static('notify.copyed', 'Збережено у буфер'),
        duration: 3000
      });
    },
    removeUniqueOptions() {
      delete this.selected.advanced.uOption
      this.$notify({
        title: this.$static('options.title', 'Опції'),
        text: this.$static('notify.removed', 'Видалено')
      });
    },
    putUniqueOptions() {
      if (window.uOptionsSave) {
        try {
          let test = JSON.parse(window.uOptionsSave)
          this.selected.advanced.uOption = test
        } catch (e) {
          console.error(e)
        }
      }
      this.$notify({
        title: this.$static('options.title', 'Опції'),
        text: this.$static('notify.updated', 'Оновлено.')
      });
    },
    closeUniqueOptions() {
      window.$('#optionsEditor').removeClass('active');
    },
    cancelOptions() {
      this.closeUniqueOptions()
      this.selected.advanced.uOption = this.cache
    },
    openFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.select)
    },
    openFileManagerVideo() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.selectVideo)
    },
    openSizeFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.selectSizeTable)
    },
    select() {
      if (!Array.isArray(this.item.images)) {
        this.item.images = []
      }
      let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
      this.item.images.push(...images);
    },
    getType(video) {
      if (video.endsWith('.mp4')) {
        return 'video/mp4'
      }
      if (video.endsWith('.webm')) {
        return 'video/webm'
      }
      if (video.endsWith('.ogg')) {
        return 'video/ogg'
      }
      return ""
    },
    selectVideo() {
      if (!Array.isArray(this.item.advanced.videos)) {
        this.item.advanced.videos = [];
      }
      let videos = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
      videos = videos.filter(x => x.endsWith(".mp4") || x.endsWith(".webm"));
      if (videos.length) {
        this.item.advanced.videos.push(...(videos).map(x => ({ url: x, type: this.getType(x) })));
      }
    },

    selectSizeTable() {
      let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
      this.sizeTable = images[0]
    },
    setTranslate(key, value) {
      if (!this.item.translate || Array.isArray(this.item.translate)) {
        this.item.translate = {}
      }
      if (!this.item.translate[this.lang]) {
        this.item.translate[this.lang] = {}
      }
      this.item.translate[this.lang][key] = value
    },
    setTranslateOptions(key, value) {
      if (!this.uOption.translate || Array.isArray(this.uOption.translate)) {
        this.uOption.translate = {}
      }
      if (!this.uOption.translate[this.lang]) {
        this.uOption.translate[this.lang] = {}
      }
      this.uOption.translate[this.lang][key] = value
    },
    validate(obj) {
      if (!obj.preview) {
        this.errors.preview = [
          this.$static('edit-item.preview-require', 'Завантажте хоча б одне зображення')
        ];

        this.$notify({
          title: this.$static('notify-images.title', 'Зображення'),
          type: 'error',
          text: this.errors.preview.join('\n'),
          duration: 10000
        });
        return false
      }
      if (!obj.category) {
        this.errors.category = [
          this.$static('edit-item.category-require', 'Оберіть категорію')
        ];

        this.$notify({
          title: this.$static('notify-сategory.title', 'Категорії'),
          type: 'error',
          text: this.errors.category.join('\n'),
          duration: 10000
        });
        return false
      }
      return true
    },
    save() {
      if (this.load) {
        return
      }
      let obj = Object.assign({}, this.selected);
      if (obj.images) {
        obj.preview = obj.images[0]
      } else {
        obj.preview = null;
      }

      if (!this.validate(obj)) {
        return;
      }
      this.load = true;
      if (this.group.length || this.removeGroup.length) {
        if (this.set_group_id) {
          this.group = this.group.map(i => {
            i.group_id = this.set_group_id;
            return i
          })
        }
        api.put('/api/item/group', { list: this.group, remove: this.removeGroupList }).then(response => response.data).then(data => {
          if (data.error) {
            this.$notify({
              title: this.$static('notify-group.title', 'Група'),
              type: 'error',
              text: data.error,
              duration: 3000
            });
          }
        })
      }
      if (obj.id) {
        api.put('/api/item', obj).then(response => response.data).then(data => {
          if (data.error) {
            this.$notify({
              title: this.$static('notify-item.title', 'Елемент'),
              type: 'error',
              text: data.error,
              duration: 3000
            });
            return
          }
          this.$emit('save', data);
          this.load = false;
          this.$notify({
            title: this.$static('notify-item.title', 'Елемент'),
            text: this.$static('notify.save', 'Збережено.'),
            duration: 3000
          });
          // this.item = data;
        });
      } else {
        api.post('/api/item', obj).then(response => response.data).then(data => {
          if (data.error) {
            this.$notify({
              title: this.$static('notify-item.title', 'Елемент'),
              type: 'error',
              text: data.error,
              duration: 3000
            });
            return;
          }
          this.$emit('add', data);
          this.load = false;
          this.$notify({
            title: this.$static('notify-item.title', 'Елемент'),
            text: this.$static('notify.save', 'Збережено.'),
            duration: 3000
          });
          // this.item = data;
        });
      }
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    remove() {
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    cancel() {
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    removeTag(index) {
      this.item.advanced.linked.splice(index, 1)
    },
    removeUpsaleTag(index) {
      this.item.advanced.upsale.splice(index, 1)
    },
    removeGroup(index) {
      this.removeGroupList.push(this.group.splice(index, 1)[0])
    },
    selectOption(key, value) {
      if (!this.item.advanced) {
        this.item.advanced = {};
      }
      if (!this.item.advanced.options || Array.isArray(this.item.advanced.options)) {
        this.item.advanced.options = {};
      }
      let target = this.item.advanced.options;
      if (key === 'tags') {
        target = this.item;
      }
      try {
        let idx = target[key].indexOf(value);
        if (idx === -1) {
          target[key].push(value)
        } else {
          target[key].splice(idx, 1)
        }
      } catch (e) {
        target[key] = [value];
      }
    },
    selectedOption(key, value) {
      let target = this.item.advanced.options;
      if (key === 'tags') {
        target = this.item;
      }
      return target && target[key] ? target[key].indexOf(value) : -1
    },

    delImage(images, index) {
      images.splice(index, 1)
    },
    moveImage(images, index, target) {
      // console.log(this['item.images'])
      let n = index + target;
      if (n > -1 && n < images.length) {
        [images[index], images[n]] = [images[n], images[index]]
      }
    },
    getOptions(id) {
      let value = this.options.find(i => i.option_id === id);
      if (value) {
        console.log("list", value.list.sort((a, b) => a.order - b.order))
        return value.list.sort((a, b) => a.order - b.order)
      }
      console.log("value", value)
      return value
    },
    async onOpen() {
      this.searchResult = []
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load)
      }
    },
    fetchOptions(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce((loading, search, vm) => {
      vm.searchResult = []
      api.post('/api/item/filter', { filter: { search } }).then(response => response.data).then(data => {
        if (data.result?.length) {
          vm.searchResult = data.result.map(i => { return { label: i.title, item: Object.assign(i, { label: i.title }) } })
        }
        loading(false);
      })
    }, 350),
    onClose() {
      this.observer.disconnect()
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.limit += 10;
        await this.$nextTick();
        ul.scrollTop = scrollTop
      }
    },
    getItem() {
      this.group = []
      this.removeGroupList = []
      this.set_group_id = undefined
      if (this.item?.id) {
        return api.get('/api/item/' + this.item.id).then(response => response.data).then(data => {
          if (data.result) {
            this.$emit('save', Object.assign(this.item, data.result, { 'update': true }));
          }
          if (data.group) {
            this.group = data.group
          }
        });
      }
    }
  },
  computed: {
    langs() {
      return this.$store.getters.settings
        && this.$store.getters.settings.public
        && this.$store.getters.settings.public.lang
        && Array.isArray(this.$store.getters.settings.public.lang) ?
        this.$store.getters.settings.public.lang : []
    },
    videos: {
      get() {
        return this.item?.advanced?.videos ? this.item.advanced.videos : []
      },
      set(value) {
        if (this.item?.advanced?.videos) {
          this.item.advanced.videos.push(value)
        } else {
          this.item.advanced.videos = [value]
        }
      }
    },
    bonusCount: {
      get() {
        try {
          return this.item.advanced.bonus
        } catch (e) {
          return ''
        }
      },
      set(value) {
        this.item.advanced = Object.assign({}, this.item.advanced, { bonus: value })
      }
    },
    uOption: {
      get() {
        return this.selected &&
          this.selected.advanced &&
          Array.isArray(this.selected.advanced.uOption) ?
          this.selected.advanced.uOption[this.uOptionIndex] : undefined
      },
      set(value) {
        this.selected.advanced.uOption[this.uOptionIndex] = value
      }
    },
    modList: {
      get() {
        return this.selected?.advanced && Array.isArray(this.selected.advanced.modList) ?
          this.selected.advanced.modList.sort((a, b) => a.order - b.order) : []
      },
      set(value) {
        this.selected.advanced.modList = value
      }
    },
    optionList() {
      return this.uOption.list.sort((a, b) => a.order - b.order)
    },
    colors: {
      get() {
        return this.selectColor ? this.selectColor.color ? this.selectColor.color : '#ffffff' : undefined;
      },
      set(value) {
        if (this.selectColor) {
          this.selectColor.color = value.hex
        }
      }
    },
    translate: {
      get() {
        return this.lang && this.item && this.item.translate && this.item.translate[this.lang] ? this.item.translate[this.lang] : {}
      },
      set(value) {
        // if (this.lang){
        //   this.item.translate[this.lang] = value
        // }
      }
    },
    translateOptions: {
      get() {
        return this.lang && this.uOption && this.uOption.translate && this.uOption.translate[this.lang] ? this.uOption.translate[this.lang] : {}
      },
      set(value) {
        // if (this.lang){
        //   this.item.translate[this.lang] = value
        // }
      }
    },
    basicLang() {
      return this.lang === ''
    },
    categoriesOptions() {
      return this.categories ? this.categories.map(x => { return { label: this.$dynamic(x, x.name, 'name'), value: x.id } }) : []
    },
    category: {
      get() {
        return this.categoriesOptions.find(x => x.value == this.item.category)
      },
      set(value) {
        this.item.category = value
      }
    },
    options() {
      return this.$store.getters.options
    },
    id() {
      return this.item && this.item.id ? this.item.id : -1
    },
    itemsCategory() {
      return this.itemList.filter(x => x.id !== this.id).reduce((a, b) => {
        let idx = a.findIndex(c => c.category === b.category);
        if (idx > -1) {
          a[idx].list.push(b);
        } else {
          a.push({ category: b.category, list: [b] });
        }
        return a;
      }, [])
    },
    itemList() {
      return this.$store.getters.itemList
    },
    itemListOptions() {
      return this.$store.getters.itemList.map(i => { return { label: i.title, item: Object.assign(i, { label: i.title }) } })
    },
    // filtered() {
    //   return this.itemListOptions.filter((item) => item.label.includes(this.search))
    // },
    paginated() {
      return this.searchResult.length ? this.searchResult : this.itemListOptions.slice(0, this.limit)
    },
    hasNextPage() {
      return this.paginated.length < this.itemListOptions.length
    },
    optionsTags() {
      return this.$store.getters.options.filter(i => i.option_id !== 'category')
    },
    categories() {
      return this.getOptions('category')
    },
    selected() {
      let result = Object.assign({}, this.item);
      if (!Array.isArray(result.size)) {
        result.size = []
      }
      if (!Array.isArray(result.color)) {
        result.color = []
      }
      return result
    },

    hot: {
      get() {
        try {
          return this.item.advanced.hot
        } catch (e) {
          return false
        }
      },
      set(value) {
        this.item.advanced = Object.assign({}, this.item.advanced, { hot: value })
      }
    },
    isService: {
      get() {
        try {
          return this.item.advanced.isService
        } catch (e) {
          return false
        }
      },
      set(value) {
        this.item.advanced = Object.assign({}, this.item.advanced, { isService: value })
      }
    },
    sizeTable: {
      get() {
        try {
          return this.item.advanced.sizeTable
        } catch (e) {
          return false
        }
      },
      set(value) {
        this.item.advanced = Object.assign({}, this.item.advanced, { sizeTable: value })
      }
    },

    metaTitle: {
      get() {
        try {
          return this.item.advanced.meta_title
        } catch (e) {
          return false
        }
      },
      set(value) {
        this.item.advanced = Object.assign({}, this.item.advanced, { meta_title: value })
      }
    },
    metaDescription: {
      get() {
        try {
          return this.item.advanced.meta_description
        } catch (e) {
          return false
        }
      },
      set(value) {
        this.item.advanced = Object.assign({}, this.item.advanced, { meta_description: value })
      }
    },

    linked: {
      get() {
        try {
          return this.item.advanced.linked
        } catch (e) {
          return []
        }
      },
      set(value) {
        // this.item.advanced = Object.assign({}, this.item.advanced, {linked: value})
      }
    },
    upsale: {
      get() {
        try {
          return this.item.advanced.upsale
        } catch (e) {
          return []
        }
      },
      set(value) {
        // this.item.advanced = Object.assign({}, this.item.advanced, {linked: value})
      }
    },
    colorsSelected() {
      return this.item.color ? this.item.color : []
    },
    sizesSelected() {
      return this.item.size ? this.item.size : []
    },
    linkedItems: {
      get() {
        return ''
      },
      set(value) {
        try {
          if (this.item.advanced.linked.indexOf(value) === -1) {
            this.item.advanced.linked.push(value)
          }
        } catch (e) {
          this.item.advanced = Object.assign({}, this.item.advanced, { linked: [value] })
        }
      }
    },
    upsaleItems: {
      get() {
        return ''
      },
      set(value) {
        try {
          if (this.item.advanced.upsale.findIndex(x => x.id === value.id) === -1) {
            let image = undefined;
            if (value.images.length) {
              image = value.images[0]
            }
            this.item.advanced.upsale.push({ id: value.id, title: value.title, image: image })
          }
        } catch (e) {
          let image = undefined;
          if (value.images.length) {
            image = value.images[0]
          }
          this.item.advanced = Object.assign({}, this.item.advanced, { upsale: [{ id: value.id, title: value.title, image: image }] })
        }
      }
    },
    group_id() {
      return this.item.group_id ? this.item.group_id : this.item.id
    },
    group_id_set: {
      get() {
        return this.set_group_id ? this.set_group_id : this.group_id
      },
      set(value) {
        this.set_group_id = value
      }
    },

    groupList: {
      get() {
        return this.group
      },
      set(value) {
        if (this.group.length === 0) {
          this.group.push(Object.assign({}, this.item, { group_id: this.group_id }))
        }
        if (this.group.findIndex(x => x.id === value.id) === -1) {
          this.group.push(Object.assign(value, { group_id: this.group_id }))
        }
      }
    }
  },
  mounted() {
    window.$('.overlay-editor .select-custom').selectpicker();
    this.optionsEditor = false
    // console.log('mounted item', this.item);
    api.get('/api/options').then(response => response.data).then(data => {
      this.$store.commit('setOptions', data)
    });
    this.getItem()
    this.observer = new IntersectionObserver(this.infiniteScroll)

    console.log("this.$store.getters.getSettings", this.$store.getters.settings)
  },
  beforeUnmount() {
    window.$('.overlay-editor select.select-custom').selectpicker('destroy');
    window.$('.overlay-editor select.select-custom option.bs-title-option').remove();
    // console.log('destroy picker')
  },
  watch: {
    'item.id'() {
      console.log(this.item)
      this.getItem()
      this.optionsEditor = false
      window.$('.overlay-editor select.select-custom').selectpicker('destroy');
      window.$('.overlay-editor select.select-custom option.bs-title-option').remove();
      this.translate = {};
      if (this.item.translate) {
        this.translate = this.item.translate
      }

      nextTick(() => {
        window.$('.overlay-editor select.select-custom').selectpicker();
      });
    }
  }
}
</script>
<style>
.vs__dropdown-toggle {
  border: 1px solid #000000;
}

.half-size {
  max-width: 50%;
}

.tab-links-holder__scroll {
  overflow-x: auto;
  overflow-y: hidden;
}

.tab-links-holder .tab-links .tab-link {
  min-height: 36px;
  max-width: 100%;
  overflow-x: auto
}
</style>